(function () {
  function isMobile() {
    var breakpoint = (window.theme && window.theme.sizes && window.theme.sizes.small) || 768;
    return window.innerWidth < breakpoint;
  }

  function moveArrowsToCounter(slider, counter) {
    var prev = slider.querySelector('.flickity-prev-next-button.previous');
    var next = slider.querySelector('.flickity-prev-next-button.next');
    var textEl = counter.querySelector('[data-gallery-counter-text]');
    if (!prev || !next || !textEl) return;

    if (prev.parentElement !== counter) counter.insertBefore(prev, textEl);
    if (next.parentElement !== counter) counter.appendChild(next);
  }

  function restoreArrowsToSlider(slider) {
    var prev = slider.querySelector(':scope > .flickity-prev-next-button.previous');
    var next = slider.querySelector(':scope > .flickity-prev-next-button.next');
    // If they're not direct children of the slider anymore, they were moved
    // into the counter - put them back for desktop's default behavior.
    if (!prev) {
      var movedPrev = document.querySelector('.product-gallery__counter .flickity-prev-next-button.previous');
      if (movedPrev) slider.appendChild(movedPrev);
    }
    if (!next) {
      var movedNext = document.querySelector('.product-gallery__counter .flickity-prev-next-button.next');
      if (movedNext) slider.appendChild(movedNext);
    }
  }

  function bindGallery(gallery) {
    var slider = gallery.querySelector('[data-product-single-media-slider]');
    var counter = gallery.querySelector('[data-gallery-counter]');
    if (!slider) return;

    var currentEl = counter ? counter.querySelector('[data-gallery-current]') : null;

    function layout(flkty) {
      if (isMobile()) {
        // The theme's default cellAlign centers each cell, splitting the
        // peek evenly on both sides. We want the image flush-left with the
        // peek entirely on the right (showing the next image's left edge).
        if (flkty.options.cellAlign !== 'left') {
          flkty.option({cellAlign: 'left'});
          flkty.resize();
        }
        if (counter) moveArrowsToCounter(slider, counter);
      } else {
        restoreArrowsToSlider(slider);
      }
    }

    function attach() {
      if (!window.theme || !window.theme.Flickity) return false;
      var flkty = window.theme.Flickity.data(slider);
      if (!flkty) return false;
      if (slider._galleryFlkty === flkty) {
        layout(flkty);
        return true;
      }

      function update() {
        if (currentEl) currentEl.textContent = flkty.selectedIndex + 1;
      }
      flkty.on('change', update);
      update();
      layout(flkty);
      slider._galleryFlkty = flkty;
      return true;
    }

    if (!attach()) {
      // The theme's own Product component owns Flickity init/destroy timing
      // (it can rebuild the slider on layout/breakpoint changes), so watch
      // for it becoming available/replaced rather than assuming one init.
      var observer = new MutationObserver(function () {
        attach();
      });
      observer.observe(slider, {attributes: true, attributeFilter: ['class']});
    }

    if (!slider._galleryResizeBound) {
      slider._galleryResizeBound = true;
      window.addEventListener(
        'resize',
        window.theme && window.theme.debounce
          ? window.theme.debounce(function () {
              var flkty = window.theme.Flickity.data(slider);
              if (flkty) layout(flkty);
            }, 200)
          : function () {
              var flkty = window.theme.Flickity.data(slider);
              if (flkty) layout(flkty);
            }
      );
    }
  }

  function init() {
    document.querySelectorAll('.product-gallery').forEach(bindGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
